import React, {useCallback, useContext, useMemo, useState} from "react";
import styled from "styled-components";
import useApprove from "../../../hooks/useApprove";
import useStake from "../../../hooks/useStake";
import {FarmContext} from "../../../contexts/farm_provider/farm_provider";
import useModal from "../../../hooks/useModal";
import {DepositModal} from "../../Farm/components/DepositModal";
import Button from "../../../components/Button";
import {Farm} from "../../../contexts/Farms/types";
import {LoopHook} from "../../../hooks/loop_hook";
import {UserAccoutContext} from "../../../contexts/farm_provider/user_account_provider";
import {NotifyRewardAmount, UpdatePause} from "../fn/admin_farm";
import {NotifyRewardAmountModel} from "./NotifyRewardAmountModel";


export const FarmCardChild: React.FC = () => {

    const [requestedApproval, setRequestedApproval] = useState(false);

    const farm: Farm = useContext(FarmContext);


    const {onApprove} = useApprove();// 申请受权


    const {notifyReward} = NotifyRewardAmount(); //  stake Fn


    const {tokenAmout} = useContext(UserAccoutContext);
    const {allowance, tokenBalance, totalSupply, apy, isPause} = LoopHook(farm);
    const {updatePause} = UpdatePause();

    const tokenName = farm.name;


    const [onPresentDeposit] = useModal(
        <NotifyRewardAmountModel
            onConfirm={notifyReward}
            tokenName={tokenName}
        />,
    );


    const handleApprove = useCallback(async () => {
        try {
            setRequestedApproval(true);
            const txHash = await onApprove();
            // user rejected tx or didn't go thru
            if (!txHash) {
                setRequestedApproval(false)
            }
        } catch (e) {
        }
    }, [onApprove, setRequestedApproval]);


    return (
        <StyledFarmCardsChild>
            <StyledFarmCardsUl>
                <li><span/>Status:<Flex>{isPause ? 'Suspend recharge':'Open deposit'}</Flex></li>
                {/*<li><span/>Staking Pool:<Flex><Value value={getBalanceNumber(totalSupply.times(4))}/></Flex></li>*/}
                {/*<li><span/> My Staking <Flex><Value value={getBalanceNumber(tokenBalance.times(4))}/></Flex></li>*/}
                {/*<li><span/>Estimated APY:*/}
                    {/*<Flex>*/}
                        {/*{apy ? `${apy.toNumber().toFixed(2)}%` : 'Loading ...'}*/}
                    {/*</Flex>*/}
                {/*</li>*/}
                {/*<li><span/>Lockup period:<Flex>14 Days</Flex></li>*/}
                {/*<li><span/>Additional rewards: <Flex>xxx</Flex></li>*/}
            </StyledFarmCardsUl>
            <BottomWidget>
                <Button
                    text={!isPause ? 'Suspend recharge':'Open deposit'}
                    onClick={updatePause}
                />
            </BottomWidget>
            <BottomWidget>
                <Button
                    text="Mining reward"
                    onClick={onPresentDeposit}
                />
            </BottomWidget>
        </StyledFarmCardsChild>
    )
};


const Flex = styled.div`
flex:1;
text-align: right;
font-weight: bold;
`;
const StyledFarmCardsChild = styled.div`
width:100%;
box-sizing: border-box;

`;
const StyledFarmCardsUl = styled.ul`
  align-items: center;
  justify-content: center;
  padding:0;
  > li{
  color:#1D2129;
  font-size:15px;
  height:30px;
  display:flex;
  align-items:center;
  text-transform:capitalize;
  
  
font-weight: 400;
color: #1D2129;

>span{
    display: #1D2129;
    width:6px;
    height:6px;
    background-color:#1D2129;
    border-radius:100px;
    margin-right:10px;
}

  
  }
`;

const BottomWidget = styled.div`
width:80%;
margin:20px auto;
`;
